export default "__VITE_ASSET__qcJi0I6Ym4zwzwZOwvZicA__"